/* src/app/dialogs/promotion-editor/promotion-editor.component.css */
.quantitybutton {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  line-height: 20px;
  margin-left: 2px;
  margin-right: 2px;
}
.order-row {
  padding: 10px;
  border: 1px solid #c5c5c5;
  margin: 5px;
}
/*# sourceMappingURL=promotion-editor.component-N24DLGAJ.css.map */
